<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.kam_addresses') }}</h5>
    </template>

    <div v-if="masterAddress" class="mb-3">
      <h6>{{ $t('sandoz.master_address') }}</h6>
      <b-row>
        <b-col md="6">
          <o-form-group :label="$t('sandoz.company_name')">
            <b-form-input v-model="masterAddress.company_name" :readonly="readonly"/>
          </o-form-group>
          <o-form-group :label="$t('sandoz.street')">
            <b-form-input v-model="masterAddress.street" :readonly="readonly"/>
          </o-form-group>
        </b-col>
        <b-col md="6">
          <o-form-group :label="$t('sandoz.zip')">
            <b-form-input v-model="masterAddress.zip" :readonly="readonly"/>
          </o-form-group>
          <o-form-group :label="$t('sandoz.city')">
            <b-form-input v-model="masterAddress.city" :readonly="readonly"/>
          </o-form-group>
        </b-col>
      </b-row>
    </div>

    <h6 class="d-flex align-items-center justify-content-between">
      <span>{{ $t('sandoz.delivery_addresses') }} ({{ deliveryAddresses.length }})</span>
      <b-btn v-if="!readonly" size="sm" variant="primary" disabled>
        <fa icon="plus"/> {{ $t('sandoz.add') }}
      </b-btn>
    </h6>
    <small v-if="!readonly" class="text-muted d-block mb-2">{{ $t('sandoz.kam_addresses_picker_note') }}</small>

    <table class="table table-sm" v-if="deliveryAddresses.length">
      <thead>
        <tr>
          <th>{{ $t('sandoz.customer_external_id') }}</th>
          <th>{{ $t('sandoz.company_name') }}</th>
          <th>{{ $t('sandoz.street') }}</th>
          <th>{{ $t('sandoz.zip') }}</th>
          <th>{{ $t('sandoz.city') }}</th>
          <th v-if="isKamSd">{{ $t('sandoz.fte') }}</th>
          <th v-if="isKamApo">{{ $t('sandoz.customer_size') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="addr in deliveryAddresses" :key="addr.id || addr.customer_external_id">
          <td>{{ addr.customer_external_id }}</td>
          <td>{{ addr.company_name }}</td>
          <td>{{ addr.street }}</td>
          <td>{{ addr.zip }}</td>
          <td>{{ addr.city }}</td>
          <td v-if="isKamSd">
            <b-form-input v-model="addr.fte" type="number" size="sm" :readonly="readonly"/>
          </td>
          <td v-if="isKamApo">
            <b-form-input v-model="addr.customer_size" size="sm" :readonly="readonly"/>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="text-muted">{{ $t('sandoz.no_delivery_addresses') }}</p>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * KAM sub-address management. The full address picker modal from kam/ContractDetail.vue
 * (subAddressListModal + axios POST /api/sandoz/kam/contracts/get-addresses) will be
 * wired in during the Phase 8 cutover. For now the section renders the existing addresses
 * read-only for delivery and editable for master.
 */
export default {
  name: 'SectionKamAddresses',
  mixins: [sectionMixin],
  computed: {
    addresses() {
      return Array.isArray(this.item.addresses) ? this.item.addresses : []
    },
    masterAddress() {
      return this.addresses.find(a => a.address_type === 'master')
    },
    deliveryAddresses() {
      return this.addresses.filter(a => a.address_type !== 'master')
    },
    isKamSd() {
      return /^KAM_SD/.test(this.item.type || '')
    },
    isKamApo() {
      return /^KAM_APO|^BIOS_KAM_APO/.test(this.item.type || '')
    }
  }
}
</script>
